/**
 * Классы мелких управляющих элементов настроек — один источник.
 *
 * ── Зачем ───────────────────────────────────────────────────────────────────
 *
 * Четыре панели объявили набор классов для полей и кнопок по месту, и к
 * четвёртой они уже разошлись: у трёх поле было на фоне карточки, у одной — на
 * фоне холста. Поодиночке это незаметно, а на одном экране рядом — нет.
 *
 * Крупные элементы живут в ui/ (Button, Input); здесь то, что в каталог не
 * попало: компактные кнопки-подписи, теги, шапка таблицы.
 */

/**
 * Поле ввода в плотной панели.
 *
 * Внешний вид держит базовый CSS (theme.css): цвет, рамка, скругление,
 * отступы, фокус. Здесь только кегль — в настройках он на ступень мельче
 * основного, иначе форма из четырёх полей не помещается в строку.
 */
export const FIELD = "h-9 text-sm";

/** Главное действие строки: заливка брендом. */
export const BUTTON_PRIMARY =
  "flex-none rounded-full border-transparent bg-primary px-3 py-1.5 text-[12px] font-medium text-primary-foreground transition-colors hover:bg-primary/90 active:scale-[0.97] disabled:opacity-45";

/**
 * Второстепенное действие: обводка, без заливки.
 *
 * Кегль 12, а не 11, начертание среднее, цвет подчинённого текста вместо
 * приглушённого, граница усиленная. На образце было видно прямо: 11 px
 * приглушённым серым рядом с залитой кнопкой читается как ВЫКЛЮЧЕННЫЙ
 * элемент, а не как второстепенный. Это основные кнопки панелей настроек —
 * «переименовать», «добавить», «отмена», — и выглядеть недоступными они не
 * должны.
 */
export const BUTTON_GHOST =
  "flex-none rounded-full border border-border-strong bg-card px-3 py-1 text-[12px] font-medium text-soft transition-colors hover:border-brand hover:text-brand active:scale-[0.97] disabled:opacity-45";

/** Опасное действие. Отличается только цветом наведения — форма та же. */
export const BUTTON_DANGER = `${BUTTON_GHOST} hover:border-destructive hover:text-destructive`;

/**
 * Стрелка перестановки в списках. Мельче обычной кнопки: их всегда две.
 *
 * С подложкой и более тёмным знаком: без них две стрелки 10 px приглушённым
 * серым сливались с фоном настолько, что их не было видно, — а это
 * единственный способ поменять порядок.
 */
export const BUTTON_ARROW =
  "grid h-4 w-5 place-items-center rounded border-transparent bg-secondary text-[11px] leading-none text-soft transition-colors hover:bg-primary hover:text-primary-foreground disabled:opacity-30";

/** Неинтерактивная метка: имя аккаунта, сотрудника, папки. */
export const TAG =
  "rounded-full bg-secondary px-2.5 py-1 text-[12px] text-foreground";

/** Ячейка шапки таблицы. */
export const TABLE_HEAD =
  "px-3 py-2 text-[11px] font-semibold uppercase tracking-[0.06em] text-muted-foreground";

/** Сообщение об ошибке над панелью. */
export const ALERT =
  "rounded-xl border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive";
